// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card--error[data-v-d5b75786]{background:red 0 0 no-repeat padding-box}.card--error[data-v-d5b75786],.card--info[data-v-d5b75786]{box-shadow:0 3px 6px rgba(0,0,0,.1607843137254902);border-radius:5px;opacity:1}.card--info[data-v-d5b75786]{background:#099 0 0 no-repeat padding-box}.card__message[data-v-d5b75786]{text-align:left;font:normal normal 700 24px/32px Segoe UI;letter-spacing:0;color:#fff!important;opacity:1;white-space:pre-wrap}", ""]);
// Exports
module.exports = exports;
